module.exports = ".feed-grid-pager {\r\n    font-size: 13px;\r\n}\r\n\r\n/* Safari only */\r\n\r\n.ui-paginator-bottom:not(:root:root) {\r\n    padding: 0px 0px 50px 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/feeds/feed-grid-pager/feed-grid-pager.component.css
// module id = ./src/app/main/feeds/feed-grid-pager/feed-grid-pager.component.css
// module chunks = main